import useStore from '../modules/store.js'

export default (key) => {
  return useStore((state) => state[key])
}
